module.exports = __webpack_public_path__ + "static/img/repast02.c40dc191.jpg";